import { METHODS } from '../constants/checkoutConstants';
import {
    emptyPaymentMethodAction,
    saveKlarnaPaymentMethodAction,
    submitKlarnaError,
} from './commonActions';

type Address = {
    city?: string | null;
    country?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    line1?: string | null;
    line2?: string | null;
    state?: string | null;
    zipCode?: string | null;
};

type Invoice = {
    readonly invoiceItems:
        | readonly ({
              readonly code: string | null;
              readonly totalAmount: {
                  readonly amount: number | null;
              } | null;
          } | null)[]
        | null;
} | null;

type Action =
    | { type: 'SAVE_KLARNA_CLIENT_TOKEN'; token: string }
    | { type: 'KLARNA_SESSION_UPDATED' }
    | { type: 'KLARNA_CLEAR_PAYMENT_SELECTION' }
    | { type: 'CHECKOUT_UPDATE_NEW_BILLING_FORM'; field: string; value: string }
    | {
          type: 'SAVE_KLARNA_SESSION';
          sessionId: string;
          buyerInvoice?: Invoice;
      };

export function saveKlarnaSession(sessionId: string, buyerInvoice?: Invoice): Action {
    return { type: 'SAVE_KLARNA_SESSION', sessionId, buyerInvoice };
}

export function saveKlarnaClientToken(token: string): Action {
    return { type: 'SAVE_KLARNA_CLIENT_TOKEN', token };
}

export type SaveKlarnaPaymentPayload = {
    sessionId: string;
    authorizationToken?: string | null;
    billingAddress: Address | null;
    klarnaNeedsFinalization?: boolean;
    buyerInvoice?: Invoice | null;
};
export function saveKlarnaPaymentMethod({
    sessionId,
    authorizationToken,
    billingAddress,
    klarnaNeedsFinalization,
    buyerInvoice,
}: SaveKlarnaPaymentPayload): ReturnType<typeof saveKlarnaPaymentMethodAction> {
    return saveKlarnaPaymentMethodAction({
        sessionId,
        authorizationToken,
        billingAddress,
        klarnaNeedsFinalization,
        buyerInvoice,
    });
}

export function klarnaSessionUpdated(): Action {
    return { type: 'KLARNA_SESSION_UPDATED' };
}

export function klarnaBillingFormFieldUpdated(field: string, value: string): Action {
    return { type: 'CHECKOUT_UPDATE_NEW_BILLING_FORM', field, value };
}

export function klarnaSubmitError(): ReturnType<typeof submitKlarnaError> {
    return submitKlarnaError();
}

export function klarnaClearPaymentSelection(): ReturnType<typeof emptyPaymentMethodAction> {
    return emptyPaymentMethodAction({
        method: METHODS.METHOD_CREDIT_CARD,
    });
}
